module.exports = __webpack_public_path__ + "img/fondo-full-melisa.e845075d.png";